<!--
 * @Author: DQL
 * @Date: 2022-04-09 14:38:12
 * @LastEditors: DQL
 * @LastEditTime: 2022-04-09 17:07:38
 * @Description: file content
-->
<template>
  <sync-dept-tree
    v-if="!asyncDept"
    v-bind="$attrs"
    v-on="$listeners"
  />
  <async-dept-tree
    v-else
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'DeptTree',
  props: {
    asyncDept: {
      type: Boolean,
      default: false
    }
  }
};
</script>
